import { Pacote } from './pacote.model';
import { Cidade } from '../endereco.model';
import { WebService } from './../gerenciamento/webservice.model';

export class Hotel {
  public Id: number;
  public selecionado: boolean;
  public Nome: string;
  public PacoteId: any;
  public Pacote: Pacote;
  public Fornecedor: string;
  public Status: number;
  public CodigoFornecedor: any;
  public ExpandirAccordion = false;
  public BloqueiaAccordion = true;
  public ExigePrePagamento: boolean;
  public Latitude: string;
  public Longitude: string;
  public Estrelas: number;
  public Cidade: Cidade;
  public Endereco: any;
  public Checkin: any;
  public Checkout: any;
  public DataReserva: any;
  public Quartos: any;
  public HotelImagem: any;
  public ValorTotalVenda: any;
  public Observacao: any;
  public opcoes: any;
  public Detalhes: any;
  public QuantidadeSelecionada : number;
  public ValorPacote : any;
  public Offline : any;
  public Opcao: number;
  public ValorTotalListagem: number;
  public WebService: WebService;
  public ReservaId: number;
  public Recomendado: boolean;
}

export class QuartoHotelRQ {
  NumeroPesquisa: number;
  Qtde: number;
  Adultos: number;
  Criancas: number[] = [];
}
export class FiltroHotel {
  public ValorMinimo: number;
  public ValorMaximo: number;
  public EstrelasMinimo = 0;
  public EstrelasMaximo = 5;
  public Nome: string;
  public Fornecedores: string[] = [];
  public Reembolsavel = -1;
  public Pensao: string[] = [];
  public Pensoes: string[] = [];
  public Localizacao: string;
}
export class BuscaHotelRQ {
  public Checkin: any;
  public Checkout: any;
  public SomentePromocao = false;
  public HotelCodigo: string;
  public Moeda: string;
  public Quartos: QuartoHotelRQ[] = [];
  public Cidade: Cidade = new Cidade();
  public Guid: string;
  public FiltroHotel: FiltroHotel = new FiltroHotel();
  public Rebusca: boolean;
  public AgenciaId: any;
  public PacoteId = 0;
  public ReservaId = 0;

}

export class HotelMapa {
  public AgrupamentoFornacedor: AgrupamentoFornecedor[] = [];
  public CodigoFornecedor: string;
  public Endereco: string;
  public Id: number;
  public Latitude: string;
  public Longitude: string;
  public Nome: string;
  public QuantidadeEstrelas: number;
  public SiglaMoeda: string;
  public ValorMaximo: number;
  public ValorMinimo: number;
}

export class AgrupamentoFornecedor {
  public CodigoFornecedor: string;
  public Fornecedor: string;
  public Valor: number;
}